export default __webpack_public_path__ + "8a05d1e089813ded3451edb7f7fd5be8.jpg";